import { render, staticRenderFns } from "./langSelect.vue?vue&type=template&id=24710153&scoped=true&"
import script from "./langSelect.vue?vue&type=script&lang=js&"
export * from "./langSelect.vue?vue&type=script&lang=js&"
import style0 from "./langSelect.vue?vue&type=style&index=0&id=24710153&prod&lang=less&scoped=true&"
import style1 from "./langSelect.vue?vue&type=style&index=1&id=24710153&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24710153",
  null
  
)

export default component.exports